import React from 'react';
import {
  List, ListItem, ListItemText, ListItemIcon, Divider, ListSubheader,
} from '@material-ui/core';
import { Link, useLocation } from 'react-router-dom';
import { Fragment } from 'react';

const SideNav = ({ routes }) => {
  const location = useLocation();

  return (
    <List disablePadding style={{ paddingTop: '16px' }}>
      {routes.map((route, index) => {
        return (
          <Fragment key={index}>
            {
              (route) ? (
                <>
                  {
                    (route.subheader ? (
                      <React.Fragment key={index}>
                        <Divider />
                        <ListSubheader>{route.subheader}</ListSubheader>
                      </React.Fragment>
                    ) : (
                      <ListItem
                        disableRipple
                        component={Link}
                        key={index}
                        button
                        to={route.href}
                        selected={location.pathname.match(route.match || route.href) !== null}
                      >
                        <ListItemIcon>{route.icon}</ListItemIcon>
                        <ListItemText primary={route.name} />
                      </ListItem>
                    ))
                  }
                </>
              ) : (
                <></>
              )
            }
          </Fragment>
        )
      })}
    </List>
  );
};

export default SideNav;
